module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ScoreStartList2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.row.start.current_show_type == 1),
      expression: "row.start.current_show_type == 1"
    }],
    attrs: {
      "row": _vm.row.start,
      "list": _vm.row.list
    }
  }), _vm._v(" "), _c('ScoreStartArmy2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.row.start.current_show_type == 2),
      expression: "row.start.current_show_type == 2"
    }],
    attrs: {
      "row": _vm.row.start,
      "list": _vm.row.list,
      "start": _vm.row.start.subject
    }
  }), _vm._v(" "), _c('ScoreStartRank2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.row.start.current_show_type == 3),
      expression: "row.start.current_show_type == 3"
    }],
    attrs: {
      "row": _vm.row.start,
      "list": _vm.row.list,
      "start": _vm.row.start.subject
    }
  }), _vm._v(" "), _c('ScoreStartSubjectRank2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.row.start.current_show_type == 4),
      expression: "row.start.current_show_type == 4"
    }],
    attrs: {
      "row": _vm.row.start,
      "start": _vm.row.start.subject,
      "list": _vm.row.rank_list
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b7a703c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/score/ScoreShow.vue
// module id = 2466
// module chunks = 0